import { useCurrentUser } from '@/hooks/data/user';
import { Progress, Space, Typography } from 'antd';

const { Text } = Typography;

export default function DownloadLimitWidget() {
   const { user, error, isLoading } = useCurrentUser();
   const downloadLimit = user?.downloadLimit;
   const downloadUsage = user?.downloadUsage;
   const downloadUsagePercentage =
      downloadUsage > downloadLimit ? 100 : Math.round((downloadUsage / downloadLimit) * 100);

   if (isLoading) {
      return <div>loading</div>;
   }

   // if downloadLimit >= 200 return unlimted as this consider unlimted downloads
   if (downloadLimit >= 200) {
      return (
         <Space size={8} direction="horizontal" wrap>
            <i
               className="fi fi-rr-infinity"
               style={{
                  color: 'var(--ant-color-primary, #1677ff)',
                  border: '1px solid',
                  borderColor: 'var(--ant-color-primary, #1677ff)',
                  borderRadius: '50%',
                  padding: '2px',
                  fontSize: '20px',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
               }}
            />
            <Text type="secondary" style={{ fontSize: 14, fontWeight: 500 }}>
               Unlimited downloads
            </Text>
         </Space>
      );
   }

   if (!downloadLimit && error) {
      return <div>error</div>;
   }

   if (user) {
      return (
         <Space direction="horizontal" size={16} align="center">
            <Progress
               type="circle"
               percent={downloadUsagePercentage}
               size={24}
               strokeWidth={12}
               strokeLinecap="round"
               status={downloadUsagePercentage > 80 ? 'exception' : 'normal'}
               showInfo={false}
            />
            <Space direction="vertical" size={0}>
               <Text type="secondary" style={{ fontSize: 12, fontWeight: 400 }}>
                  Download limit
               </Text>
               <Text type="secondary" style={{ fontSize: 14, fontWeight: 500 }}>
                  {downloadUsage} / {downloadLimit} downloads
               </Text>
            </Space>
         </Space>
      );
   }

   return <div></div>;
}
